export const now = new Date()